import { Link } from 'react-router-dom';

export default function PublicFooter() {
	const year = new Date().getFullYear();

	return (
		<footer className="public-footer border-t border-slate-200 bg-white">
			<div className="max-w-3xl mx-auto px-6 py-6 flex flex-col items-center gap-3 sm:flex-row sm:justify-between">
				<nav className="flex items-center gap-6 text-sm">
					<Link to="/" className="text-slate-600 hover:text-blue-600">
						Home
					</Link>
					<Link to="/privacy" className="text-slate-600 hover:text-blue-600">
						Privacy
					</Link>
					<Link to="/support" className="text-slate-600 hover:text-blue-600">
						Support
					</Link>
				</nav>
				<p className="text-xs text-slate-400">
					&copy; {year} Best National Carports
				</p>
			</div>
		</footer>
	);
}
